export default "/images/vendor/flag-icon-css/flags/4x3/vn.svg?2301f6f466f2e744e48a5bbaa83269eb";